<!-- eslint-disable vue/max-attributes-per-line -->
<template>
  <div class="container">
    <HeaderLayout :title="`${this.$store.getters.userInfo.tenant.shortName}分区计量全览图`"
                  workUrl="/partition/workbench" />
    <mainWarp class="mainWarp"
              :inputValue="value"></mainWarp>
    <div class="main">
      <big-map-partition ref="bigmap"
                         code="zone_metering_legend" />
    </div>
  </div>
</template>
<script>
import HeaderLayout from '@/layouts/HeaderLayout'
import BigMap from './components/BigMap.vue'
import BaiDuMap from './components/BaiDuMap.vue'
import mainWarp from './components/mainWarp.vue'
import BigMapPartition from './components/BigMapPartition.vue'
import vueSeamlessScroll from 'vue-seamless-scroll'

export default {
  components: {
    [BigMap.name]: BigMap,
    HeaderLayout,
    BigMapPartition,
    BaiDuMap,
    mainWarp,
    vueSeamlessScroll
  },
  data () {
    return {
      value: {
        sysTab: 2,
        isDispose: 0
      },
      listData: [],
      map: null,
      openQueryTable: false,
      diameter: null,
      material: null,
      dataList: [],
      speed: 80,
      colee: '',
      colee1: '',
      colee2: '',
      dataWarp: ''
    }
  },
  created () {
    // this.getScrollDataList()
    this.getList()
  },
  computed: {},
  methods: {
    getList () {
      // 工单统计
      this.$http
        .get('/pipe-network/remote_water_meter_alarm_messages/list', {
          params: {
            sysTab: 2,
            isDispose: 0
          }
        })
        .then((res) => {
          this.data = res.data
        })
      if (this.dataList.length < 2) {
        this.$nextTick(() => {
          this.goScroll()
        })
      }
    },
    goScroll () {
      const vm = this
      this.colee2 = document.getElementById('ulDiv2')
      this.colee1 = document.getElementById('ulDiv')
      this.colee = document.getElementById('dataWarp')
      this.colee2.innerHTML = this.colee1.innerHTML // 克隆colee1为colee2

      let MyMar1 = setInterval(this.Marquee1, this.speed) // 设置定时器
      // 鼠标移上时清除定时器达到滚动停止的目的

      this.colee.onmouseover = function () {
        clearInterval(MyMar1)
      }

      this.colee.onmouseout = function () {
        MyMar1 = setInterval(() => {
          vm.Marquee1()
        }, vm.speed)
      }

      this.$once('hook:beforeDestroy', () => {
        clearInterval(MyMar1)
        MyMar1 = null
      })
    },
    Marquee1 () {
      // 当滚动至colee1与colee2交界时
      if (this.colee2.offsetTop - this.colee.scrollTop <= 0) {
        this.colee.scrollTop -= this.colee1.offsetHeight + 20 // colee跳到最顶端
      } else {
        this.colee.scrollTop++
      }
    }
  }
}
</script>
<style lang="less" scoped>
.mainWarp {
  z-index: 99;
}

.container {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;

  .main {
    height: 100%;
    flex: 1;
  }

  .ul-scroll {
    margin-left: -36px;

    li {
      width: 500px;
      padding: 5px;

      span {
        margin-left: 5px;
        margin-right: 5px;
      }
    }
  }
}
</style>
